import {
  ActivitySector,
  ActivitySectorHttp,
} from '@data/models/activity-sector.interface';

export const toActivitySector = (
  activitySectorHttp: Partial<ActivitySectorHttp>,
): ActivitySector => {
  return {
    id: activitySectorHttp.id ?? '',
    label: activitySectorHttp.attributes?.label ?? '',
    code: activitySectorHttp.attributes?.code ?? '',
  };
};
